import React, { useEffect, useState } from 'react';
import { Layout } from '@cloud/atom-ui';
import { getPrivacyInfo } from './thunk';
import DOMPurify from 'dompurify';
import { replaceHtmlDomain } from "@src/utils/common";
import './style.m.css';

const BottomFooter = props => {
  const { locale } = props;
  const { Footer } = Layout;
  const [privacyInfo, setPrivacyInfo] = useState();

  // 获取智能硬件市场
  const getCopyRightInfo = () => {
    getPrivacyInfo().then(res => {
      setPrivacyInfo(res?.data);
    })
  };

  useEffect(() => {
    getCopyRightInfo();
  }, []);

  return (
    <Footer>
      <svg dangerouslySetInnerHTML={{ __html: replaceHtmlDomain(DOMPurify.sanitize(privacyInfo?.isoIcon)) }} className='svgIcon' />
      <span style={{ marginRight: 20 }}>{locale === 'en' ? privacyInfo?.isoTextEn : privacyInfo?.isoTextCn}</span>
      <span>{locale === 'en' ? privacyInfo?.copyRightEn : privacyInfo?.copyRightCn}</span>
    </Footer>
  );
};

export default BottomFooter;